import moment from 'moment-timezone';

// Every date-range filter in the portal uses Eastern Time calendar days (the practice's business timezone).
// The server applies the same rule: start = 00:00 ET on the start day, end = all of the end day ET.
export const TZ = 'America/New_York';
export const YMD = 'YYYY-MM-DD';

export const PRESETS = [
    { key: 'thisMonth', label: 'This month' },
    { key: 'lastMonth', label: 'Last month' },
    { key: 'last7', label: 'Last 7 days' },
    { key: 'last30', label: 'Last 30 days' },
    { key: 'thisQuarter', label: 'This quarter' },
    { key: 'custom', label: 'Custom' },
];

export const nowEt = (now = new Date()) => moment(now).tz(TZ);
export const todayEt = (now) => nowEt(now).format(YMD);

/** { startDate, endDate } ('YYYY-MM-DD', ET) for a preset key; unknown keys fall back to 'This month'. */
export const presetRange = (key, now) => {
    const t = nowEt(now);
    const today = t.format(YMD);
    switch (key) {
        case 'lastMonth': {
            const m = t.clone().subtract(1, 'month');
            return { startDate: m.clone().startOf('month').format(YMD), endDate: m.clone().endOf('month').format(YMD) };
        }
        case 'last7':
            return { startDate: t.clone().subtract(6, 'days').format(YMD), endDate: today };
        case 'last30':
            return { startDate: t.clone().subtract(29, 'days').format(YMD), endDate: today };
        case 'thisQuarter':
            return { startDate: t.clone().startOf('quarter').format(YMD), endDate: today };
        default:
            return { startDate: t.clone().startOf('month').format(YMD), endDate: today };
    }
};

/** Default for every range filter: first day of the current ET month -> today (ET). */
export const defaultRange = (now) => presetRange('thisMonth', now);

export const detectPreset = (startDate, endDate, now) => {
    const hit = PRESETS.find((p) => {
        if (p.key === 'custom') return false;
        const r = presetRange(p.key, now);
        return r.startDate === startDate && r.endDate === endDate;
    });
    return hit ? hit.key : 'custom';
};

export const isYmd = (v) => typeof v === 'string' && moment(v, YMD, true).isValid();

/** '10/01/2026 – 10/29/2026' (MM/DD/YYYY, en dash); a single day shows one date. */
export const formatRange = (startDate, endDate) => {
    if (!isYmd(startDate) || !isYmd(endDate)) return 'Choose dates';
    const s = moment(startDate, YMD);
    const e = moment(endDate, YMD);
    if (s.isSame(e, 'day')) return s.format('MM/DD/YYYY');
    return `${s.format('MM/DD/YYYY')} – ${e.format('MM/DD/YYYY')}`;
};

// react-datepicker works with local Date objects; convert by calendar date only (never through UTC).
export const ymdToDate = (ymd) => {
    if (!isYmd(ymd)) return null;
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d);
};
export const dateToYmd = (date) => (date ? moment(date).format(YMD) : null);

/** Read ?startDate=&endDate= from a query string, falling back to the default range. */
export const rangeFromSearch = (search, now) => {
    const q = new URLSearchParams(search || '');
    const s = q.get('startDate');
    const e = q.get('endDate');
    return isYmd(s) && isYmd(e) && s <= e ? { startDate: s, endDate: e } : defaultRange(now);
};
